import { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';

/**
 * Editable list of short labels rendered as chips. "Add +" turns into an inline input;
 * Enter commits, Escape or an empty blur cancels. Duplicates (case-insensitively) are
 * dropped, because the brand profile API addresses these rows by label.
 */
class TagList extends Component {
    constructor() {
        super();

        this.inputRef = createRef();
        this.onStartAdding = this.onStartAdding.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onCommit = this.onCommit.bind(this);

        this.state = {
            isAdding: false,
            value: '',
        };
    }

    componentDidUpdate(_, prevState) {
        if (this.state.isAdding && !prevState.isAdding) {
            this.inputRef.current?.focus();
        }
    }

    onStartAdding() {
        this.setState({ isAdding: true, value: '' });
    }

    onChange(e) {
        this.setState({ value: e.target.value });
    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.onCommit();
        } else if (e.key === 'Escape') {
            this.setState({ isAdding: false, value: '' });
        }
    }

    onCommit() {
        const value = this.state.value.trim();
        const exists = this.props.items.some((item) => item.toLowerCase() === value.toLowerCase());

        if (value && !exists) {
            this.props.onChange([...this.props.items, value]);
        }
        this.setState({ isAdding: false, value: '' });
    }

    render() {
        const { t, items, disabled, placeholder, renderItem, containerClassName } = this.props;

        return (
            <div className={`settings-tags ${containerClassName ?? ''}`}>
                {items.map((item) => (
                    <span className="settings-tag" key={item}>
                        {renderItem ? renderItem(item) : item}
                        <button
                            type="button"
                            className="settings-tag-remove"
                            disabled={disabled}
                            title={t('ai_tracking.projects.settings.remove')}
                            onClick={() =>
                                this.props.onChange(items.filter((value) => value !== item))
                            }
                        >
                            <i className="icon-x-close" />
                        </button>
                    </span>
                ))}
                {this.state.isAdding ? (
                    <input
                        ref={this.inputRef}
                        className="settings-tag-input"
                        type="text"
                        value={this.state.value}
                        placeholder={placeholder}
                        disabled={disabled}
                        onChange={this.onChange}
                        onKeyDown={this.onKeyDown}
                        onBlur={this.onCommit}
                    />
                ) : (
                    <button
                        type="button"
                        className="settings-tag settings-tag-add"
                        disabled={disabled}
                        onClick={this.onStartAdding}
                    >
                        {t('ai_tracking.projects.settings.add')} <i className="icon-plus" />
                    </button>
                )}
            </div>
        );
    }
}

export default withTranslation()(TagList);
